import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  getPolyglot,
  PolyglotComponentProps,
  withPolyglot,
} from '../../../../../../i18n';
import ListItem from '../../../../../../theme/components/ListItem';
import { Group } from '../../../../../../redux/groups/api/group.model';
import GroupModel from '../../../../../../redux/groups/api/GroupModel';
import { RootState, useAppSelector } from '../../../../../../redux/store.model';
import { groupButtonsRightsSelector } from '../../../../../../redux/groups/selectors/groupRightsSelectors';
import {
  RouterComponentProps,
  withRouter,
} from '../../../../../../util/route-dom';

import { getAlarmActiveBySelector } from '../../../../../../redux/incident/selectors/getAlarmActiveBySelector';
import {
  GroupActionsGrid,
  GroupActionsList,
} from '../../../../../../components/DeviceManager/Group/Overview/GroupsOverview/GroupActions/GroupActions';
import { CompanyIcon, StoreIcon } from '../../../../theme/icons';
import { useTheme } from '@mui/material';
import { GroupType } from '../../../../redux/group/model';
import { useGetChildCount } from '../../../../hooks/useGetChildCount';

interface GroupCardProps
  extends PolyglotComponentProps,
    RouterComponentProps,
    OwnProps,
    ConnectedComponentProps {}
interface OwnProps {
  group?: Group;
  loading?: boolean;
  groupId: string;
  moduleSelected: string;
}

export function GroupCardSimple(props: GroupCardProps) {
  const { group, groupId, navigate, loading } = props;

  const theme = useTheme();
  const polyglot = getPolyglot();

  const { data: alarmsActive } = useAppSelector((state) =>
    getAlarmActiveBySelector(state, {
      groupId: groupId,
    })
  );

  const isStorePath =
    group?.attributes && group?.attributes['BUSINESS_ROLE'] === GroupType.Store;

  const onNavigateToMerchandiser = () => {
    if (!isStorePath) {
      navigate(`/companies/group/${group?.id}`);
      return;
    }
    navigate(`/merchandiser/${group?.id}`);
  };

  const childCount = useGetChildCount(group as Group);
  const merchandisers = polyglot.t('freshwatch.store.countMerchandisers', {
    smart_count: childCount.merchandisersCount,
  });
  const stores = polyglot.t('freshwatch.store.countStores', {
    smart_count: childCount.storesCount,
  });

  const subtitle =
    group?.attributes?.BUSINESS_ROLE === GroupType.Store
      ? merchandisers
      : `${stores} - ${merchandisers}`;
  return (
    <ListItem
      key={groupId}
      id={groupId}
      name={group?.name}
      subtitle={subtitle}
      loading={loading}
      iconURL={group?.iconURL}
      iconNode={
        <div style={{ height: '2rem', color: theme.palette.primary.main }}>
          {isStorePath ? (
            <StoreIcon height={'150px'} />
          ) : (
            <CompanyIcon height={'150px'} />
          )}
        </div>
      }
      className={GroupModel.getClassesNamesFromDevice(group)}
      onClick={onNavigateToMerchandiser}
      buttons={<GroupActionsList group={group} />}
      menuButtons={<GroupActionsGrid group={group} />}
      ItemContainerProps={{ sx: { px: 2 } }}
      error={alarmsActive.length > 0}
    />
  );
}

const mapStateToProps = (
  state: RootState,
  props: OwnProps &
    RouterComponentProps<{
      groupId?: string;
    }>
) => ({
  ...groupButtonsRightsSelector(state, props),
  accessToken: state.auth.accessToken,
});

const connector = connect(mapStateToProps);

export type ConnectedComponentProps = ConnectedProps<typeof connector>;

const FreshwatchGroupCard = withPolyglot(
  withRouter(connector(GroupCardSimple))
);
export default FreshwatchGroupCard;
